<nav class="navbar navbar-expand-xl navbar-light bg-light p-4">
  <div class="logo_Profile">
    <img src="../../../../assets/images/acc_header_logo.svg" style="height: 60px; cursor: pointer"
      routerLink="/main//home" />
  </div>
  <a class="navbar-brand"></a>
  <!-- <button
    class="navbar-toggler"
    type="button"
    (click)="showHideHead()"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button> -->

  <!-- <div
    class="collapse navbar-collapse"
    id="navbarSupportedContent"
    [ngClass]="{ collapse: showHead == true }"
    data-target=".navbar-collapse"
  >
    <ul class="navbar-nav mr-auto"></ul>
  </div> -->
  <div class="last_Items">
    <!-- <div class="bell_div"> -->
    <div class="bell-wrapper">
      <img
        src="../../../../assets/images/ghanta (2).svg"
        class="mt-2 notification-bell"
        #Btn
        style="height: 30px; margin-right: 25px; cursor: pointer"
        (click)="getNotiDetail(notiModel, Btn)"
      />
      <span class="notification-badge">{{ notificationCount || 0 }}</span>
    </div>
    <!-- </div> -->
    <div class="dropdown" >
      <img
        src="{{
          userProfilePic
            ? userProfilePic
            : '../../../../assets/images/dummy_Pic.svg'
        }}"
        class="profile-pic"
        (click)="toggleDropdown(true)"
      />
      <div class="dropdown-content" *ngIf="isDropdownOpen">
        <a href="" routerLink="/main/profile" class="cursor" (click)="toggleDropdown(false)" ><img src="../../../../assets/images/user.svg" /> View
          Profile</a>
        <!-- <a href="#view-profile" routerLink="/main/saved-choir" class="cursor"
          ><img src="../../../../assets/images/viewsaved.svg" /> View Saved
          Choir</a
        > -->
        <a href="" routerLink="/main/view-booking" class="cursor" (click)="toggleDropdown(false)"
          ><img src="../../../../assets/images/calendar-search.svg" /> View
          Booking</a
        >
        <a href="" routerLink="/main/pending-booking" class="cursor"(click)="toggleDropdown(false)"
          ><img src="../../../../assets/images/transaction_pending.svg" /> Due
          Transactions
        </a>
        <!-- <a href="#view-profile" routerLink="/main/newsletter" class="cursor"
          ><img src="../../../../assets/images/news.svg" /> View Newsletter
        </a> -->
        <!-- routerLink="/main/uniform" -->
        <a class="cursor" (click)="uniformRedirect()" style="cursor: pointer" ><img
            src="../../../../assets/images/uniform1.svg" /> Uniform Section
        </a>
        <a (click)="viewHandbook($event)" class="cursor" style="cursor: pointer" ><img
            src="../../../../assets/images/booklet.svg" /> View Handbook
        </a>
        <a class="cursor" style="cursor: pointer" routerLink="/main/change-password" (click)="toggleDropdown(false)" ><img
            src="../../../../assets/images/lock_acc.svg" /> Change Password
        </a>
        <a
          class="cursor"
          style="cursor: pointer"
          routerLink="/main/payment-cards"
          ><img
            width="25"
            class="me-1"
            src="../../../../assets/images/debit_cards.svg" 
          />Saved Cards
        </a>
        <a class="cursor" (click)="openLogoutModal(logoutModal); toggleDropdown(false)" style="cursor: pointer" ><img src="../../../../assets/images/logout.svg" /> Logout</a
        >
        <!-- <a href="#view-booking">View Booking</a>
        <a href="#view-saved-events">View Saved Events</a> -->
      </div>


      <ng-template #logoutModal let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Confirm Logout</h4>
          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to log out?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" style="background-color: #4a3a8c; color: white;" (click)="modal.dismiss('cancel')">Cancel</button>
          <button type="button" class="btn" (click)="confirmLogout(modal)" style="background-color: #f3a43f; color: white;">Yes, Logout</button>
        </div>
      </ng-template>



    </div>
  </div>
</nav>
<!-- routerLink="/main/profile" -->
<ng-template #notiModel let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>

  <div class="modal-header d-flex justify-content-between align-items-center">
    <h5 class="modal-title m-0">Notifications</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeModal('dismiss')"
    ></button>
  </div>

  <div class="modal-body p-3" style="max-height: 400px; overflow-y: auto">
    <div class="container-fluid">
      <!-- Mark all as read -->
      <div
        *ngIf="notiData?.length > 0"
        class="d-flex justify-content-between align-items-center mb-3"
      >
        <h6 class="mb-0 fw-bold">
          You have {{ notiData.length }} notifications
        </h6>
        <button
          class="btn btn-outline-primary btn-sm"
          (click)="markAllAsRead()"
        >
          Mark all as read
        </button>
      </div>

      <!-- Notification List -->
      <ng-container *ngIf="notiData?.length > 0">
        <div
          class="notification-item mb-3 p-2"
          *ngFor="let item of notiData"
          [ngClass]="{ unread: !item?.isRead, read: item?.isRead }"
        >
          <p class="fw-semibold mb-1">{{ item?.title }}</p>

          <!-- Normal content -->
          <p class="mb-1" *ngIf="item?.title !== 'Payment Reminder'">
            {{ item?.content }}
          </p>

          <!-- Payment Reminder -->
          <p class="mb-1" *ngIf="item?.title === 'Payment Reminder'">
            {{ item?.content.split("here:")[0] }}
            <a
              (click)="openPaymentWindow(item?.content)"
              class="text-primary"
              style="cursor: pointer"
              >here</a
            >.
          </p>

          <div class="text-end">
            <small class="text-muted">{{
              convertStamp(item?.insertDate)
            }}</small>
          </div>
        </div>
      </ng-container>

      <!-- No Notification Placeholder -->
      <div class="text-center mt-4" *ngIf="!notiData || notiData.length === 0">
        <img
          src="../../../../assets/images/nonotification.png"
          alt="No Notifications"
          class="img-fluid"
          style="max-height: 200px"
        />
        <p class="mt-2 text-muted">You're all caught up!</p>
      </div>
    </div>
  </div>
</ng-template>